import BaseFormPage from "../../../../base/BaseFormPage";
import EmployeeFormPresenter from "../employee-form/EmployeeFormPresenter";
import DropDown from "../../../../components/common/DropDown";
import Divider from "../../../../components/common/Divider";
import InputFactory from "../../../../components/InputFactory";

export default class Attachment extends BaseFormPage {
  constructor(props) {
    super(props);
    this.presenter = new EmployeeFormPresenter(this);
    this.state = {
      selectedFiles: {
        personalDataSheet: [],
        appointment: [],
        positionDescriptionFrom: [],
        oathOfOffice: [],
        serviceRecord: [],
        AssumptionOfDuty: [],
        contractOfService: [],
        copiesOfCertificatedEligibilities: [],
        copiesOfDiploma: [],
        tor: [],
        conventions: [],
        copyOfBirth: [],
        medicalCertificated: [],
        nbiClearance: [],
        NoticeOfSalaryAdjustments: [],
        personalOrders: [],
        letterDirective: [],
        travelOrders: [],
        copiesOfDisciplinaryActions: [],
        individualPerformance: [],
        swornStatementOfAssets: [],
        othersFile: [],
      },
    };
  }

  componentDidMount() {
    this.presenter.componentDidMount();
    this.syncSelectedFiles(this.props.object);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.object !== this.props.object) {
      this.syncSelectedFiles(this.props.object);
    }
  }

  syncSelectedFiles = (object = this.props.object) => {
    const selectedFiles = { ...this.state.selectedFiles };

    Object.keys(selectedFiles).forEach((key) => {
      if (object && Object.prototype.hasOwnProperty.call(object, key)) {
        selectedFiles[key] = Array.isArray(object[key]) ? object[key] : [];
      } else {
        selectedFiles[key] = [];
      }
    });

    this.setState({ selectedFiles });
  };

  handleFileChange = (title, files) => {
    const nextObject = {
      ...(this.props.object || {}),
      [title]: Array.isArray(files) ? files : [],
    };

    this.props.setObject(nextObject);
    this.setState((prevState) => ({
      selectedFiles: {
        ...prevState.selectedFiles,
        [title]: Array.isArray(files) ? files : [],
      },
    }));
  };

  getCollectionName() {
    return "employees";
  }

  render() {
    const { selectedFiles } = this.state;
    const schema = this.getSchema(this.getCollectionName());
    const dropdowns = Object.keys(selectedFiles).map((title) => {
      const files = Array.isArray(selectedFiles[title])
        ? selectedFiles[title]
        : [];

      return {
        title: `${schema.fields[title].label} (${files.length})`,
        content: (
          <InputFactory
            type="File"
            onChange={(files) => this.handleFileChange(title, files)}
            value={files}
            className="form-control"
          />
          // <FileUpload
          //   key={title}
          //   label={"Upload Employee's Document"}
          //   attachments={selectedFiles[title]}
          //   onFileChange={(files) => this.handleFileChange(title, files)}
          //   object={this.props.object}
          // />
        ),
      };
    });

    return (
      <>
        {/* <img src={selectedFiles.Diploma} /> */}
        <div>
          <br></br>
          <Divider title={"Attachments"} />
          <DropDown dropdowns={dropdowns} />
        </div>

        <div className="mt-4 d-flex justify-content-end">
          <div className="border" style={{ borderRadius: "4px" }}>
            <button
              style={{
                borderRadius: "4px 0 0 4px",
                backgroundColor: "#fff",
              }}
              type="button"
              className="btn btn-light fs-sm me-0"
              onClick={this.props.onClickPrev}
            >
              Previous
            </button>
            <button
              style={{
                borderRadius: " 0 4px 4px 0",
                backgroundColor: "#29457c",
              }}
              disabled={this.props.isSubmitting}
              onClick={() => {
                if (this.props.isSubmitting) return;
                (this.props.presenter || this.presenter).showDialogSubmit(
                  this.props.object,
                );
              }}
              className="btn btn-primary fs-sm me-0"
            >
              {this.props.isSubmitting ? "Saving..." : "Submit"}
            </button>
          </div>
        </div>
      </>
    );
  }
}
